import { defineStore } from 'pinia'
import type Alliance from '@/types/Alliance.ts'

export const useAllianceStore = defineStore('allianceStore', {
  state: () => ({
    alliances: new Map<number, Alliance>()
  }),

  actions: {
    // Alliances are managed by websockets, so no fetchAlliances method is needed

    // Update a single alliance in the store
    updateAlliance(alliance: Alliance) {
      this.alliances.set(alliance.id, alliance)
    },

    // Remove a single alliance from the store
    removeAlliance(allianceId: number) {
      this.alliances.delete(allianceId)
    },

    // Get a single alliance from the store
    getAlliance(allianceId: number) {
      return this.alliances.get(allianceId)
    }
  }
})
